import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import SectionContent from "./../scripts/sectionContent";

const Brands = () => {

    const data = useStaticQuery(graphql`
        query brandSectionQuery {
            allContentfulSectionContent(filter: {section: {eq: "Brands"}, page: {eq: "Homepage"}}) {
                edges {
                    node {
                        id
                        content {
                            childMarkdownRemark {
                                html
                                rawMarkdownBody
                            }
                        }
                        contentType
                    }
                }
            }
            allContentfulBrandLogos {
                edges {
                    node {
                        id
                        websiteUrl
                        image {
                            fluid(quality: 100) {
                                src
                            }
                        }
                    }
                }
            }
        }
    `);

    const sectionContent = new SectionContent(data.allContentfulSectionContent);

    return (
        <section id="brands" className="brands section section-ntm container mx-auto">
            <div className="flex flex-col md:flex-row">
                <div className="col w-full md:w-5/12 text-center md:text-left mb-8">
                    <h3 className="section__heading text-2xl mb-4 md:ml-16 md:w-1/2">{ sectionContent.getContent('heading').rawMarkdownBody }</h3>
                    <p>{ sectionContent.getContent('description').rawMarkdownBody }</p>
                </div>
                <div className="col flex w-full md:w-5/12 mx-auto items-start">
                    <ul className="flex flex-wrap justify-center mx-auto">
                        {
                            data.allContentfulBrandLogos.edges.map(edge => (
                                <li key={ edge.node.id }><a href={ edge.node.websiteUrl } target="_blank" rel="noreferrer"><img src={ edge.node.image.fluid.src } alt="Logo"/></a></li>
                            ))
                        }
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default Brands;